
import { IDirective } from "angular";
import { showReportDialog } from "@sentry/browser";

export function OpenSentryFeedbackDirective() : IDirective {
    return {
        restrict: "A",
        link: (scope, el, attrs) => {
            el.on("click", () => {
                const eventID = attrs[OpenSentryFeedbackDirective.selector];
                try {
                    showReportDialog(eventID ? {
                        eventId: eventID
                    } : undefined);
                } catch (ex) {
                    el.hide();
                }
            })
        }
    }
}
OpenSentryFeedbackDirective.selector = "sentryOpenFeedback";
